<div class="sk-gsearch-wrap">
  <div class="sk-gsearch-box" [class.sk-gsearch-box--active]="searchOpen">
    <mat-icon class="sk-gsearch-icon">search</mat-icon>
    <input
      type="text"
      class="sk-gsearch-input"
      [placeholder]="'Search pages and reports' | translate"
      [(ngModel)]="searchQuery"
      (ngModelChange)="onSearchInput($event)"
      autocomplete="off"
    />
    <button
      *ngIf="searchQuery"
      type="button"
      class="sk-gsearch-clear"
      (click)="clearSearch()"
      [attr.aria-label]="'Clear search' | translate"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Backdrop -->
  <div class="sk-gsearch-backdrop" *ngIf="searchOpen" (click)="closeSearch()"></div>

  <!-- Results dropdown -->
  <div class="sk-gsearch-dropdown" *ngIf="searchOpen">
    <ng-container *ngIf="searchResults.length > 0; else noNavResults">
      <button
        *ngFor="let result of searchResults"
        type="button"
        class="sk-gsearch-result"
        [class.sk-gsearch-result--pbi]="result.resultType === 'pbi'"
        (click)="navigateToResult(result.link)"
      >
        <mat-icon *ngIf="!isIconFont(result.icon)" class="sk-gsearch-result-icon" [class.sk-gsearch-result-icon--pbi]="result.resultType === 'pbi'">{{ result.icon }}</mat-icon>
        <span *ngIf="isIconFont(result.icon)" class="sk-gsearch-result-icon {{ result.icon }}"></span>
        <span class="sk-gsearch-result-text">
          <span class="sk-gsearch-result-title">{{ result.title }}</span>
          <span *ngIf="result.parentTitle" class="sk-gsearch-result-parent">{{ result.parentTitle }}</span>
        </span>
        <span *ngIf="result.resultType === 'pbi'" class="sk-gsearch-result-pbi-badge">PBI</span>
        <mat-icon class="sk-gsearch-result-arrow">arrow_forward</mat-icon>
      </button>
    </ng-container>
    <ng-template #noNavResults>
      <div class="sk-gsearch-empty">
        <mat-icon class="sk-gsearch-empty-icon">search_off</mat-icon>
        <span>{{ 'No pages found' | translate }}</span>
      </div>
    </ng-template>
  </div>
</div>
